import { useObservableEagerState } from "observable-hooks";
import { useClientEnvironment } from "~/environment/ClientEnvironmentContext";

export function useIsServiceWorkerUpdateBeingInstalled() {
  const environment = useClientEnvironment();
  return useObservableEagerState(environment.serviceWorker.isUpdateBeingInstalled$);
}
